import { Box, Grid, IconButton, Rating, CircularProgress } from '@mui/material'
import { useContext, useEffect } from 'react';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API'
import { env } from '../../../../core/Env'
import { NoResult } from '../../empty/Index'
import { View } from './View';
import { Waypoint } from 'react-waypoint';
import { SnakeLoader } from '../../../../core/loader/SnakeLoader'
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';

export const Product = () => {
    const { tool_state, reviews_state } = useContext(ToolContext)
    const { __SESSION } = tool_state
    const { inftScroll, listLoader, lid, reviewList, view, details, search } = reviews_state
    const { uaccess } = __SESSION.data
    
    const overAllTotal = (v) => {
        const { product_rating, sellers_rating, shipping_rating } = v
        const total = product_rating + sellers_rating + shipping_rating 
        const average = total / 3
        return average
    }
    const header = [
        {name: 'No', size: 1.5},
        {name: 'Date Created', size: 2},
        {name: 'Name', size: 2},
        {name: 'Promo', size: 3},
        {name: 'Overall Rating', size: 2},
        {name: 'Action', size: 1.5},
    ]
    const handlerView = (id) => {
        view.set({...view.data, show: !view.data.show, id: id, loader : true})
        if (id === undefined) {
            details.set({info: '', imgs: []})
        }
    }

    const readList = async(val) => {
        if (val === 0) {
            listLoader.set(true)
            inftScroll.set(true)
        }
        let r;
        if (search.data !== "") {
            r = await rqx.get(`<<tool>>/${env()}/reviewsRatings/product_list`, {company_id: uaccess[0].company_id, limit: 10, lastId: val, search: search.data})
        }else{
            r = await rqx.get(`<<tool>>/${env()}/reviewsRatings/product_list`, {company_id: uaccess[0].company_id, limit: 10, lastId: val})
        }
        if (r) {
            let last_id;
            for(let index = 0; index < r.length; index++){
                last_id = r[index].id
            }
            lid.set(last_id)
            if (val === 0 || val === undefined || val === '') {
                reviewList.set(r)
            }else{
                reviewList.set([...reviewList.data, ...r])
            }
            if (r.length === 0) {
                listLoader.set(false)
                inftScroll.set(false)
                return
            }
            listLoader.set(false)
        }
    }

    const loadMoreData = () => {
        console.log('1')
        readList(lid.data)
    }
    
    useEffect(() => {
        if (search.data) {
            const searching = setTimeout(() => {
                readList(0)
            }, 300);
            return () => {
                clearTimeout(searching)
            }
        }else{
            readList(0)
        }
        // eslint-disable-next-line
    },[search.data])

    return (
        <Box height="100%" width="100%" display="flex" flexDirection="column" className="overflowY">
            <Grid container bgcolor="#E0E8E8" color="#333333" py="12px" px="16px" borderRadius={2} fontSize={14} fontWeight={700} mb={1}>
                {
                    header.map((v,k) => (
                        <Grid item xs={v.size} key={k} textAlign={k === 4 || k === 5 ? 'center': 'left'}>
                            {v.name}
                        </Grid>
                    ))
                }
            </Grid>
            {
                listLoader.data ? (
                    <Box height="100%" width="100%" display="flex" alignItems="center" justifyContent="center">
                        <CircularProgress />
                    </Box>
                ):(
                    reviewList.data.length === 0 ? (
                        <NoResult />
                    ):(
                            <Box height="100%" width="100%" className="overflowY">
                                {
                                    reviewList.data.map((v,k, d) => (
                                        <Grid container  display="flex" alignItems="center" border="1px solid #215D9580" 
                                            color="#333333" py="8px" px="16px" boxShadow="0px 3px 3px 0px #00000033" 
                                            borderRadius={2} fontSize={14} mb={1} key={k}
                                        >
                                            <Grid item xs={1.5}>
                                                {d.length - k}
                                            </Grid>
                                            <Grid item xs={2}>
                                                {moment(v.created_at).format('MM/D/YYYY')}
                                            </Grid>
                                            <Grid item xs={2}>
                                                {
                                                    v.first_name !== null || v.first_name !== '' ? (
                                                        `${v.first_name} ${v.middle_name} ${v.last_name}`
                                                    ):(
                                                        v.mobile_num !== null || v.mobile_num !== '' ? (
                                                            v.mobile_num
                                                        ):(
                                                            v.email
                                                        )
                                                    )  
                                                }
                                            </Grid>
                                            <Grid item xs={3}>
                                                {v.promo_name}
                                            </Grid>
                                            <Grid item xs={2} textAlign="center">
                                                <Rating readOnly value={overAllTotal(v)} precision={0.05} />
                                            </Grid>
                                            <Grid item xs={1.5} textAlign="center">
                                                <IconButton onClick={() => handlerView(v.id)}>
                                                    <VisibilityIcon />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    ))
                                }
                                {
                                    inftScroll.data && (
                                        <Waypoint onEnter={loadMoreData}>
                                            <Box display="flex" justifyContent="center" my={2}>
                                                <SnakeLoader bg="#11783C" size= "10px" distance= "5px"  />
                                            </Box>
                                        </Waypoint>
                                    )
                                }
                            </Box>
                            
                    )
                )
            }
            {
                view.data.show &&
                    <View view={view} handlerView={handlerView} details={details}  />
            }
        </Box>
    )
}
